module.exports = __webpack_public_path__ + "img/terroir-charcoal-1.be90de0c.jpg";